module.exports = __webpack_public_path__ + "static/media/b2_p13_clickable.08d2e94c.mp3";